import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// components
import { Loader } from '@components';
import { Login } from '@pages';
import { useAuthContext } from './AuthContext';
import { Api, getToken } from '@utils';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user, isVerified, isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [requestedLocation, setRequestedLocation] = React.useState<
    string | null
  >(null);

  React.useEffect(() => {
    if (isInitialized && !user.verified && user.email && !isVerified) {
      navigate('/verify?email=' + user?.email);
    }
  }, [isInitialized, isVerified, user]);

  // React.useEffect(() => {
  //   const _setRedirect = async (redirect: string) => {
  //     const token = getToken();

  //     const { data } = await Api.put(
  //       '/profile',
  //       { redirect },
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );

  //     if (data.success) {
  //       localStorage.removeItem('redirect');
  //     }
  //   };

  //   const redirect = localStorage.getItem('redirect');
  //   if (isInitialized && !isAuthenticated && redirect) {
  //     _setRedirect(redirect);
  //   }
  // }, [isAuthenticated, isInitialized]);

  if (!isInitialized) {
    return <Loader />;
  }

  if (isInitialized && !isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
